import styled from "styled-components";

export const Container = styled.div`
  text-align: center;
  label.uploadPhoto {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    gap: 15px;
    margin-bottom: 10px;

    > div {
      display: flex;
      align-items: center;
      font-size: 14px;
      border: 2px solid #0a5587;
      padding: 3px 12px;
      border-radius: 20px;
      max-width: 100%;
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    svg {
      width: 18px;
      height: 18px;
      margin-left: 5px;
      cursor: pointer;
    }
  }
  .custom-file-input {
    z-index: 1 !important;
  }
  .custom-file-input:before {
    content: "Upload Specification*";
    display: inline-block;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    background: rgba(0, 0, 0, 0.1);
    color: #000;
    padding: 9px 32px;
    font-family: "latomedium";
    border-radius: 5px;
    position: absolute;
    left: auto;
    top: 0;
    font-size: 16px;
    cursor: pointer;
  }
`;
export const DesTag = styled.div`
  color: black;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.005em;
`;
